/**
 * @file loading加载mixin
 */
export default {
  data() {
    return {
      loading: false
    };
  },
  watch: {
    '$route'() {
      this.loading = false;
    }
  },
  methods: {
    handleLoadingStatus(loading) {
      this.loading = loading;
    }
  }
};
